<div class="escalation-chat-container">
    <div class="content">
        <div *ngIf="isLoading" class="loading">
            <div class="spinner"></div>
            <p>Loading chat service...</p>
        </div>

        <div *ngIf="error" class="error-message">
            <h3>⚠️ Unable to Load Chat</h3>
            <p>{{ error }}</p>
            <div class="fallback-contact">
                <p><strong>Please use one of these alternative methods to reach support:</strong></p>
                <ul>
                    <li><strong>Email:</strong> <a href="mailto:support@example.com">support&#64;example.com</a></li>
                    <li><strong>Phone:</strong> <a href="tel:+18005551234">1-800-555-1234</a></li>
                    <li><strong>Support Portal:</strong> <a href="https://support.example.com" target="_blank">https://support.example.com</a></li>
                </ul>
            </div>
        </div>

        <div *ngIf="!isLoading && !error" class="escalation-info">
            <h3>Escalation Details</h3>
            <div class="details">
                <div *ngIf="escalationDetails.reason" class="detail-item">
                    <strong>Reason:</strong>
                    <span>{{ escalationDetails.reason }}</span>
                </div>
                <div *ngIf="escalationDetails.priority" class="detail-item">
                    <strong>Priority:</strong>
                    <span class="priority-badge" [class.high]="escalationDetails.priority === 'high' || escalationDetails.priority === 'urgent'">
                        {{ escalationDetails.priority | uppercase }}
                    </span>
                </div>
                <div *ngIf="escalationDetails.timestamp" class="detail-item">
                    <strong>Time:</strong>
                    <span>{{ escalationDetails.timestamp | date:'medium' }}</span>
                </div>
            </div>
            <details *ngIf="escalationMessage" class="message-details">
                <summary>View full escalation message</summary>
                <pre>{{ escalationMessage }}</pre>
            </details>
        </div>
    </div>
</div>
